import script from "./BusinessComponent.vue?vue&type=script&lang=ts"
export * from "./BusinessComponent.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__